module.exports = __webpack_public_path__ + "static/media/casetta-3x2-checkin-campo-accessori-noleggiocampi.978b33ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/extra/casetta/casetta-3x2-checkin-campo-accessori-noleggiocampi.jpg
// module id = 650
// module chunks = 0